// extracted by mini-css-extract-plugin
module.exports = {"root":"J_bk"};